import React, {useEffect} from 'react'
import {Button} from 'react-bootstrap'
import eqxApiInstance from '../classes/eqxApi'
import EqxForm, {
    eqxFormStatuses,
    EqxFormSubmit,
    useFormState,
    type EqxFormProps,
    type eqxFormStateManager,
} from './EqxForm/EqxForm'
import EqxModal, {useDerivedModalState, useModalState, type eqxModalStateManager} from './EqxModal/EqxModal'

interface EqxFormModalProps extends EqxFormProps {
    api: eqxApiInstance
    form?: eqxFormStateManager
    modal?: eqxModalStateManager
    header?: React.ReactNode
    footer?: React.ReactNode
    title: React.ReactNode
    children: React.ReactNode
    onHide?: () => void
    shown?: boolean
}
const EqxFormModal = (props: EqxFormModalProps) => {
    const modalState = useModalState(props.modal)
    const formState = useFormState(props.form)

    let {modal, form, onHide, title, footer, header, shown, ...formProps} = {...props}

    const onClickCancel = () => {
        modalState.hide()
    }
    const onClickSubmit = () => {
        formState.submit()
    }
    useEffect(() => {
        if (formState.status == eqxFormStatuses.COMPLETE) {
            modalState.hide()
            formState.reset()
        }
    })

    if (!footer) {
        footer = (
            <>
                <Button variant="outline-secondary" onClick={onClickCancel}>
                    Cancel
                </Button>
                <EqxFormSubmit loading={formState.isLoading()} onClick={onClickSubmit} />
            </>
        )
    }
    return (
        <EqxModal state={modalState} footer={footer} title={props.title} onHide={onHide} shown={shown}>
            <EqxForm {...formProps} state={formState} api={props.api}>
                {props.children}
            </EqxForm>
        </EqxModal>
    )
}

export {
    EqxFormModal as default,
    eqxFormStateManager,
    eqxModalStateManager,
    useDerivedModalState,
    useFormState,
    useModalState,
    type EqxFormModalProps,
}
